import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { SpecialtyPlansService } from 'src/app/modules/admin/services/specialty-plans.service';
import { PaymentLinkService } from 'src/app/modules/indication/services/payment-link.service';
import { PatientService } from 'src/app/services/patient.service';
import { DefaultResponse } from 'src/app/pages/base.interface';
import { ScheduleServiceV2 } from '../../../../services/schedule.service';
import { IndicationServiceV2 } from '../../../../services/indication.service';
import { IndicationOutputDTO } from '../../../../contracts/indication';

export const indicationScheduleResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const indicationService = inject(IndicationServiceV2);
  const patientService = inject(PatientService);
  const paymentLinkService = inject(PaymentLinkService);
  const specialtyPlansService = inject(SpecialtyPlansService);
  const scheduleService = inject(ScheduleServiceV2);

  const id = route.paramMap.get('id') || route.parent?.paramMap.get('id');

  if (isNaN(Number(id)) || id === 'novo') {
    router.navigate(['v2', 'indications']);
    return of(null);
  }

  const indicationId = Number(id);

  return indicationService.getById(indicationId).pipe(
    switchMap((indication: DefaultResponse<IndicationOutputDTO>) => {
      const patientId = indication.data.patientId;

      return forkJoin({
        indication: of(indication.data),
        patient: patientService.getPatientById(patientId),
        billing: paymentLinkService.getBillingByIndicationId(indicationId),
        specialties: specialtyPlansService.findAll(),
        schedules: scheduleService.findAllByIndicationId(indicationId),
      });
    }),
    catchError((error) => {
      console.error(error);
      router.navigate(['v2', 'indications']);
      return of(null);
    })
  );
};
